import _extends from "@babel/runtime/helpers/extends";
import { designTokens } from '@tui-react/design-tokens';
import { common } from './common';
import { DARK_THEME, DESKTOP_PLATFORM } from './constants';
import { createCSSVariables } from './utils';
export const night = _extends({}, common, createCSSVariables(designTokens.shadow, '--tui-shadow', DESKTOP_PLATFORM, DARK_THEME), Object.keys(designTokens.animation).reduce((acc, type) => {
  return _extends({}, acc, createCSSVariables(designTokens.animation[type], `--tui-animation-${type}`, DESKTOP_PLATFORM, DARK_THEME));
}, {}), Object.keys(designTokens.gradient).reduce((acc, type) => {
  return _extends({}, acc, createCSSVariables(designTokens.gradient[type], `--tui-gradient-${type}`, DESKTOP_PLATFORM, DARK_THEME));
}, {}), Object.keys(designTokens.color).reduce((acc, type) => {
  return _extends({}, acc, createCSSVariables(designTokens.color[type], `--tui-${type}`, DESKTOP_PLATFORM, DARK_THEME));
}, {}), {
  // Явно добавляем css переменную, которая используется в компоненте Modal
  '--tui-component-dialog-fullscreen-transparent-background': '#202020CC',
  // Явно добавляем фантомную css переменную, которая эквивалента neutral-4
  '--tui-background-neutral-5': '#FFFFFF4D'
});